<template>
    <div v-loading="loading">
        <h2 style="margin-top: 20px;">Notes</h2>
        <textarea class="form-control" v-model="note"></textarea>
        <div class="form-check">
          <input type="checkbox"
                 class="form-check-input"
                 id="is-channel-message"
                 v-model="isChannelMessage"
          />
          <label class="form-check-label" for="is-channel-message">@channel</label>
        </div>
        <div style="margin: 10px 0">
            <btn :click="addNote" icon="fas fa-plus">Add Note</btn>
            <billing-notes-upload-file :budget_period_id="billing_period_id" @changed="refresh"></billing-notes-upload-file>
        </div>

        <div class="bil-files" v-if="data">
            <template v-for="item in data.notes">
                <div class="bil-note" v-if="item.type == 'note'">
                    <div class="bil-note-content"><div v-if="item.is_pinned"><i class="fas fa-thumbtack"></i> Pinned</div>{{ item.text }}</div>
                    <div class="bil-note-footer">
                        {{ item.updated_by }} · {{ item.updated_at }} · <a href="#" @click.prevent="editNote(item)">edit</a>
                        <template v-if="!item.is_pinned">
                        · <a href="#" @click.prevent="pinNote(item)">pin</a>
                        </template>
                        <template v-if="item.is_pinned">
                        · <a href="#" @click.prevent="unpinNote(item)" v-if="item.is_pinned">unpin</a>
                        </template>
                        · <a href="#" @click.prevent="removeNote(item)">delete</a>
                    </div>
                </div>
                <div class="bil-file" v-if="item.type == 'file'">
                    <a :href="item.file_url" target="_blank" class="bil-file-download">{{ item.file_name }}</a>
                    <div class="bil-note-footer">
                        {{ item.updated_by }} · {{ item.updated_at }} · <a href="#"
                                                                           @click.prevent="removeFile(item)">delete</a>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import BillingNotesUploadFile from "./billing-notes-upload-file";

export default {
        components: {BillingNotesUploadFile},
        props: [
            'billing_period_id'
        ],
        data() {
            return {
                data: null,
                loading: true,
                note: '',
                isChannelMessage: false
            };
        },
        watch: {
            billing_period_id() {
                this.refresh();
            }
        },
        methods: {
            refresh() {
                this.loading = true;
                return axios.get(url(`admin/budget-note/${this.billing_period_id}/list`))
                    .then(response => {
                        this.data = response.data
                        this.loading = false;
                    });
            },
            addNote() {
                return axios.post(url(`admin/budget-note/${this.billing_period_id}/add`), {
                    text: this.note,
                    isChannelMessage: this.isChannelMessage
                }).then(response => {
                    this.note = '';
                    this.isChannelMessage = false;
                    this.refresh();
                });
            },
            editNote(note) {
                return this.$prompt('', 'Note', {
                    confirmButtonText: 'Save',
                    cancelButtonText: 'Cancel',
                    inputType: 'textarea',
                    inputValue: note.text,
                    closeOnClickModal: false
                }).then(({ value }) => {
                    return axios.post(url(`admin/budget-note/${this.billing_period_id}/note/${note.id}/save`), {
                        text: value
                    }).then(response => {
                        this.refresh();
                    });
                })
            },
            removeNote(note) {
                return axios.post(url(`admin/budget-note/${this.billing_period_id}/note/${note.id}/remove`))
                    .then(response => {
                        this.refresh();
                    });
            },
            removeFile(file) {
                return axios.post(url(`admin/budget-file/${this.billing_period_id}/file/${file.id}/remove`))
                    .then(response => {
                        this.refresh();
                    });
            },
            pinNote(note) {
                return axios.post(url(`admin/budget-note/${this.billing_period_id}/note/${note.id}/pin`))
                    .then(response => {
                        window.location.reload();
                    });
            },
            unpinNote(note) {
                return axios.post(url(`admin/budget-note/${this.billing_period_id}/note/${note.id}/unpin`))
                    .then(response => {
                        window.location.reload();
                    });
            }
        },
        mounted() {
            this.refresh();
        }
    }
</script>

<style>
.bil-files {
}

.bil-file, .bil-note {
    padding: 15px 0;
    border-bottom: 1px solid #ccc;
}

.bil-note-footer {
    color: #666;
}

.bil-note-content, .bil-file-download {
    font-weight: bold;
    white-space: pre-line;
}
</style>
